import React from "react";
import "../App.css";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  const firstpage = () => {
    navigate("/elgamal");
  };

  return (
    <div className="flex justify-center">
      <div className="flex flex-col items-center">
        <div>
          <h1 className="text-3xl pt-8">Understanding ElGamal public key cryptosystem</h1>
        </div>
        <div className="pt-10">
          <h1>Instructions</h1>
        </div>
        <div class="instruction-box">
        <p>
  <strong>Step 1: Key generation process:</strong> Students select/input the value of p, g, and b (Bob’s private key). The public key is calculated by the system, which also clearly visualizes the data (alongside the calculation involved) known by Alice, Bob, and Eve.
  <br /><br />
  <strong>Step 2: Message Encryption:</strong> Students input the value of m – the message sent by Alice as well as Alice’s private key “a”. The p, g, and public key values have to be input by the students after seeing the previous output. Computations of A, S, and X (cipher) are shown by the system based on the input values.
  <br /><br />
  <strong>Step 3: Message Sending:</strong> The system visualizes the message being sent from Alice to Bob. Also, all the values known by each of the entities are always highlighted to demonstrate/visualize the security process.
  <br /><br />
  <strong>Step 4: Message Decryption:</strong> The message values are shown, and the student has to select the corresponding values for each option (A, S, X). The calculation involved in the decryption process is shown till the message is finally decrypted (i.e., X is decrypted to m) without “Eve” being able to calculate anything.
</p>

        </div>
        <div class="button-holder">
          <div class="next-button" onClick={firstpage}>
            NEXT
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
